import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import duration from 'dayjs/plugin/duration';
import localeData from 'dayjs/plugin/localeData';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import weekYear from 'dayjs/plugin/weekYear';
import weekday from 'dayjs/plugin/weekday';
import packageMetadata from '../../../package.json';
import { optionalEnv } from '@/shared/config';
import { configureLogging, createLogger, errorFields } from '@/shared/logging';
import { reloadOnStaleBuild } from './staleBuildReload';

const appLog = createLogger('app');
let initialized = false;

export async function initializeApplicationRuntime(): Promise<void> {
	if (initialized) return;
	initialized = true;

	dayjs.extend(duration);
	dayjs.extend(utc);
	dayjs.extend(timezone);
	dayjs.extend(customParseFormat);
	dayjs.extend(advancedFormat);
	dayjs.extend(weekday);
	dayjs.extend(localeData);
	dayjs.extend(weekOfYear);
	dayjs.extend(weekYear);
	dayjs.extend(relativeTime);

	if (import.meta.env.DEV) {
		const { hijackEffects } = await import('stop-runaway-react-effects');
		hijackEffects({ callCount: 500, timeLimit: 1000 });
	}

	const logging = configureLogging(optionalEnv('NEXT_PUBLIC_LOG_LEVEL'));
	document.documentElement.dataset.brand = optionalEnv('NEXT_PUBLIC_LOGO_TYPE') ?? 'globalai';
	appLog.info('application initialized', {
		build_version: packageMetadata.version,
		log_level: logging.level,
		log_level_source: logging.source,
		rendering: 'client'
	});

	reloadOnStaleBuild();

	window.addEventListener('unhandledrejection', (event) => {
		if (event.reason?.name !== 'HttpError') return;
		event.preventDefault();
		appLog.debug('handled HTTP rejection', errorFields(event.reason));
	});
}
